import React, { useEffect, useCallback, useState } from 'react'
import { Main, MainBody, MainTop, MainTopTitle, WhiteBox, BoxHeader } from '@/components/Layout'
import Resx from '@/components/Resx'
import LoadingIndicator from '@/components/LoadingIndicator'
import IndividualDetail from '@/internal-app/pages/dataCrossing/individual-detail'
import { useDispatch } from '@/hooks/dispatch'
import { actionCreators } from '@/store/dataCrossing'
import { useReduxState } from '@/hooks/reduxState'
import { Col, Row } from 'reactstrap'
import { useLocalization } from '@/hooks/localization'
import getEnumTranslation from '@/enums/enums'
import { ProblematicCombinationState } from '@/enums/problematicCombinationState'
import { dataCrossingProblematicCombinationStatus } from '@/internal-app/pages/dataCrossing/dataCrossingProblematicCombinationStatus'
import { getName } from '@/utils/nameHelpers'
import Icon from '@/components/Icon'
import { Button } from '@/components/button'
import { openDialog as openDialogActionCreator } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'

export const ProblematicCombinationsDetail = React.memo(function ProblematicCombinationsDetail (props) {
  const realPersonId = props.match.params.id
  const { localize } = useLocalization()
  const { delinquentRetrieving, delinquentIndividuals, delinquentSetting } = useReduxState(useCallback(state => ({
    delinquentRetrieving: state.dataCrossing.delinquentRetrieving,
    delinquentIndividuals: state.dataCrossing.delinquentIndividuals,
    problematicCombinationSetting: state.dataCrossing.problematicCombinationSetting
  }), []))

  const [highlight, setHighlight] = useState({ ids: [], ok: true })
  const { individuals, problematicCombinations } = delinquentIndividuals

  const [getRealPersonDetail, openDialog] = useDispatch([
    actionCreators.getRealPersonDetail,
    openDialogActionCreator
  ])
  useEffect(() => {
    getRealPersonDetail(realPersonId)
  }, [getRealPersonDetail, realPersonId])

  const statusEnumValue = (problematicCombinations.some(x => x.state === ProblematicCombinationState.enum.NotChecked))
    ? ProblematicCombinationState.enum.NotChecked
    : problematicCombinations.some(x => x.state === ProblematicCombinationState.enum.NotOk)
      ? ProblematicCombinationState.enum.NotOk
      : ProblematicCombinationState.enum.Ok

  const status = getEnumTranslation({ localize, enumName: ProblematicCombinationState.enumName, value: statusEnumValue })

  const renderButtonColor = useCallback((state) => {
    switch (state) {
      case 0:
        return 'secondary'
      case 1:
      case 3:
        return 'success'
      case 2:
        return 'danger'
    }
  }, [])

  const renderProblematicCombinations = useCallback((individual) =>
    problematicCombinations.filter(x =>
      x.individualId === individual.id || (x.secondIndividualId === individual.id)).map(x => {
      const secondIndividual = individuals.find(y => y.id === (x.individualId === individual.id ? x.secondIndividualId : x.individualId))
      const tooltip = localize('DataCrossings.ProblematicCombinationTooltip_' + x.type, [getName(secondIndividual)])
      return <Button
        key={x.id}
        title={tooltip}
        color={renderButtonColor(x.state)}
        onClick={() => openDialog({
          dialogType: dialogTypes.problematicCombination,
          combination: x,
          individuals: individuals.filter(y => x.individualId === y.id || x.secondIndividualId === y.id)
        })}
        onMouseEnter={() => setHighlight({
          ids: [x.individualId, x.secondIndividualId],
          ok: (x.state === ProblematicCombinationState.enum.Ok || x.state === ProblematicCombinationState.enum.Resolved)
        })}
        onMouseLeave={() => setHighlight({ ...highlight, ids: [] })}
      >
        <Icon name='error' />
      </Button>
    })
  , [highlight, individuals, localize, openDialog, problematicCombinations, renderButtonColor])

  return (
    <Main>
      <MainTop>
        <MainTopTitle backUrl='/data-crossings-delinquents'>
          <Resx name='DataCrossings.DelinquentDetail' />
        </MainTopTitle>
      </MainTop>
      <MainBody transparent className='be'>
        {delinquentRetrieving
          ? <LoadingIndicator />
          : <React.Fragment>
            <h4>
              <Resx name='DataCrossings.ProblematicCombinationStatus' />
              <span className={'status status--' + dataCrossingProblematicCombinationStatus(statusEnumValue) + ' inline'}>{status}</span>
            </h4>
            <Row className='detail-boxes'>
              {delinquentSetting
                ? <LoadingIndicator />
                : individuals.map(x =>
                  <WhiteBox key={x.id}
                    className={highlight.ids.includes(x.id)
                      ? (highlight.ok ? 'white-box__highlight_green' : 'white-box__highlight_red')
                      : null}>
                    <Col lg='12'>
                      <div className='comparison-header'>
                        <BoxHeader className='header'>{getName(x)}</BoxHeader>
                        {renderProblematicCombinations(x)}
                      </div>
                      <IndividualDetail individual={x} localize={localize} />
                    </Col>
                  </WhiteBox>
                )
              }
            </Row>
          </React.Fragment>
        }
      </MainBody>
    </Main>
  )
})



// WEBPACK FOOTER //
// ./src/internal-app/pages/dataCrossing/problematic-combinations-detail.js